import { RefreshCw, CheckCircle2, AlertCircle, AlertTriangle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Alert, AlertDescription } from '@/components/ui/alert'

interface ConnectionStatusProps {
  config: any
  testResult: any
  onTest: () => void
}

export function ConnectionStatus({ config, testResult, onTest }: ConnectionStatusProps) {
  return (
    <Card className="border-0 shadow-sm">
      <CardHeader className="bg-white border-b-0">
        <CardTitle className="text-base">Estado de Conexión</CardTitle>
      </CardHeader>
      <CardContent className="pt-6">
        {config ? (
          <>
            <div className="mb-4">
              <div className="flex items-center gap-3">
                <div
                  className={`w-3 h-3 rounded-full ${
                    config.is_active ? 'bg-green-500 animate-pulse' : 'bg-gray-400'
                  }`}
                />
                <div>
                  <p className="font-medium text-sm">
                    {config.is_active ? 'Activa' : 'Inactiva'}
                  </p>
                  <p className="text-xs text-muted-foreground">{config.whatsapp_number}</p>
                </div>
              </div>
            </div>

            <Button
              onClick={onTest}
              className="w-full"
              variant="outline"
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              Probar Conexión
            </Button>

            {testResult && (
              <Alert
                className={`mt-4 ${
                  testResult.success
                    ? 'border-green-500 bg-green-50'
                    : 'border-red-500 bg-red-50'
                }`}
              >
                {testResult.success ? (
                  <CheckCircle2 className="h-4 w-4 text-green-600" />
                ) : (
                  <AlertCircle className="h-4 w-4 text-red-600" />
                )}
                <AlertDescription
                  className={testResult.success ? 'text-green-800' : 'text-red-800'}
                >
                  {testResult.mensaje}
                </AlertDescription>
              </Alert>
            )}
          </>
        ) : (
          <Alert className="border-yellow-500 bg-yellow-50">
            <AlertTriangle className="h-4 w-4 text-yellow-600" />
            <AlertDescription className="text-yellow-800">
              No hay configuración activa
            </AlertDescription>
          </Alert>
        )}
      </CardContent>
    </Card>
  )
}
